import {Timestamp} from 'rxjs';

export class BaseResponse<T, F> {
  requestId?: string;
  requestDate?: Timestamp<any>;
  messageCode?: string;
  message?: string;

  data?: T;
  optional?: F;

  static getMessage = (res: any) => {
    if (res) {
      const response: BaseResponse<any, any> = Object.assign(res, new BaseResponse());
      if (response?.messageCode) {
        return response.message;
      } else {
        return 'Hệ thống đang bận. Vui lòng thử lại sau';
      }
    } else {
      return "Hệ thống đang bận. Vui lòng thử lại sau";
    }

  }
}
